export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/arrow-right.6ad55240.svg","height":16,"width":18};